export default __webpack_public_path__ + "static/media/2.ada1328f.png";